import { render, staticRenderFns } from "./shipping_status.vue?vue&type=template&id=d5031448&"
import script from "./shipping_status.vue?vue&type=script&lang=js&"
export * from "./shipping_status.vue?vue&type=script&lang=js&"
import style0 from "./shipping_status.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports